module.exports = __webpack_public_path__ + "static/media/10.Highlighted Spread.5196ffb5.jpg";